

/**
 * Keeps track of whether updates on scroll are currently allowed.
 */
export default class ScrollUpdateChecker {

    constructor() {
        this.isScrollUpdateAllowed = true;
    }

    /**
     * 
     * @param {boolean} value true if updates on scroll should currently be allowed, false otherwise
     */
    setScrollUpdateAllowed(value) { 
        this.isScrollUpdateAllowed = value;
    }

    
    /**
     * @returns whether scroll update is currently allowed
     */
    checkScrollUpdate() {
        return this.isScrollUpdateAllowed;
    }    
}